<template>
  <div>Demo</div>
</template>

<script>
export default {
  name: "Demo",

  data() {
    return {};
  },

  created() {},

  beforeDestroy() {},

  watch: {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
